module.exports = __webpack_public_path__ + "static/media/logo.2469f78c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 403
// module chunks = 0